import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { TogglerModule,TooltipCopyLinkComponent } from '@personal-area/global/ui';
import { IconSpriteModule } from '@personal-area/icon-sprite';

import { AccountTypePipe } from '../../pipes/account-type.pipe';
import { AccountViewerLeverageComponent } from '../account-viewer-leverage/account-viewer-leverage.component';
import { AccountViewerPasswordModule } from '../account-viewer-password/account-viewer-password.module';
import { AccountViewerSwapFreeComponent } from '../account-viewer-swap-free/account-viewer-swap-free.component';
import { LeveragePopupModule } from '../leverage-popup/leverage-popup.module';
import { AccountViewerOverviewComponent } from './account-viewer-overview.component';

@NgModule({
  declarations: [AccountViewerOverviewComponent],
  imports: [
    AccountViewerPasswordModule,
    AccountViewerLeverageComponent,
    AccountViewerSwapFreeComponent,
    TranslateModule,
    MatTooltipModule,
    MatDialogModule,
    TogglerModule,
    IconSpriteModule,
    CommonModule,
    TooltipCopyLinkComponent,
    AccountTypePipe,
    LeveragePopupModule,
  ],
  exports: [AccountViewerOverviewComponent],
})
export class AccountViewerOverviewModule {
}
